import { render, staticRenderFns } from "./SurveysModal.vue?vue&type=template&id=645395fe&scoped=true&"
import script from "./SurveysModal.vue?vue&type=script&lang=js&"
export * from "./SurveysModal.vue?vue&type=script&lang=js&"
import style0 from "./SurveysModal.vue?vue&type=style&index=0&id=645395fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645395fe",
  null
  
)

export default component.exports